import React, { memo, Suspense } from 'react';
import PropTypes from 'prop-types';
import { LeaseDealsEntities } from 'site-modules/lease-deals/constants/prop-types';
import { LeaseDealsCompactCard } from 'site-modules/lease-deals/components/lease-deals-compact-card/lease-deals-compact-card';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';

export const LeaseDealsListViewCardList = memo(
  ({ deals, photos = undefined, isMobile, isShop4931ZeroDownRoute = false }) => {
    return (
      <ul className="list-unstyled pb-0">
        {deals.map(deal => {
          const photo = photos?.find(({ styleIds }) => styleIds[deal.styleId]);
          return (
            <ErrorBoundary key={deal.styleId}>
              <Suspense fallback={null}>
                <li className="mb-0_75">
                  <LeaseDealsCompactCard
                    photo={photo}
                    isLazyImage
                    isMobile={isMobile}
                    isShop4931ZeroDownRoute={isShop4931ZeroDownRoute}
                    {...deal}
                  />
                </li>
              </Suspense>
            </ErrorBoundary>
          );
        })}
      </ul>
    );
  }
);

LeaseDealsListViewCardList.propTypes = {
  deals: LeaseDealsEntities.Deals.isRequired,
  photos: PropTypes.arrayOf(PropTypes.shape({})),
  isMobile: PropTypes.bool.isRequired,
  isShop4931ZeroDownRoute: PropTypes.bool,
};

LeaseDealsListViewCardList.displayName = 'LeaseDealsListViewCardList';
